import React from 'react'
import { Image, Flex, Link, Text } from 'theme-ui'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'
import { nanoid } from 'nanoid'
import generateLink from '../../../helpers/generateLink'
import checkIfExternalLink from '../../../helpers/checkIfExternalLink'

export default function ContentBoxes(props) {
  const {
    options,
    variantName,
    city,
    // configData,
    // businessData,
    isMultiLocationSite
    // locationIndex,
  } = props

  const { ctaNames, ctaLinks, images } = options

  const getOptionToLoopOver = () => {
    // finds the longest array out of the selected content data below and returns a object key

    const contentData = { ctaNames, ctaLinks, images }
    let longestArrayIndex = null
    let longestArray = 0

    Object.values(contentData).forEach((content, index) => {
      if (content?.length > longestArray) {
        longestArray = content.length
        longestArrayIndex = index
      }
    })

    const objectToLoop = Object.keys(contentData)[longestArrayIndex]
      ? Object.keys(contentData)[longestArrayIndex]
      : false
    return objectToLoop
  }

  if (!options[getOptionToLoopOver()]) {
    return null
  }

  return (
    <Flex variant={`${variantName}.contentBoxes`}>
      {options[getOptionToLoopOver()].map((image, index) => (
        <Link
          key={nanoid()}
          variant={`${variantName}.box`}
          href={ctaLinks ? generateLink(ctaLinks[index], isMultiLocationSite, city) : ''}
          target={`${checkIfExternalLink(ctaLinks[index]) ? '_blank' : ''}`}
          rel={`${ctaLinks && checkIfExternalLink(ctaLinks[index]) ? 'noreferrer' : ''}`}
        >
          <Image variant={`${variantName}.image`} src={images[index]} alt={`contentbox${index}`} />
          <Text variant={`${variantName}.ctaName`}>
            {ctaNames[index]} &nbsp;&nbsp;
            <FontAwesomeIcon icon={faArrowRight} />
          </Text>
        </Link>
      ))}
    </Flex>
  )
}
